module.exports = __webpack_public_path__ + "img/gallery-5.a7bd02ff.jpg";